import {
  getAvailableIntegrationsQueryOptions,
  getIntegrationsQueryOptions,
} from "@/queries/integrations";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration",
)({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    context.queryClient.prefetchQuery(getIntegrationsQueryOptions());
    context.queryClient.prefetchQuery(getAvailableIntegrationsQueryOptions());
  },
});

function RouteComponent() {
  return <Outlet />;
}
